import { StorageKey } from '../constants';

export const get = <T>(key: StorageKey): Promise<T> => {
    const value = window.sessionStorage.getItem(key);

    if (value) {
        return Promise.resolve(JSON.parse(value) as T);
    }
    return Promise.reject(new Error(`${key} not in sessionStorage`));
};

export const set = <T>(key: StorageKey, value: T) => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
};

export const remove = (key: StorageKey) => {
    window.sessionStorage.removeItem(key);
};
